import { http, HttpResponse } from 'msw';
import { PlessService } from '../../../app/shared/pless-service.model';

export const kymw59Handlers = [
  http.post(
    PlessService.SERVICE.getCwsPlanGoodsList.url,
    async ({ request }) => {
      const req = await request;
          return HttpResponse.json(getCwsPlanGoodsListResponse);
          // return ResponseUtils.getSysError();
          // return ResponseUtils.getE0100();
          // return ResponseUtils.get500();
    }
  ),
];

const getCwsPlanGoodsListResponse = {
    status: 'ok',
    message: '処理完了',
    result: {
      obj: {
        FileName:
          '/tmp/peace/data/WebData/downloadtemp/EC企画商品一覧表_2025221_173649.tsv',
      },
    },
  };
